// Permissions de l'espace d'administration, alignées sur les droits de l'API.

// Rôles autorisés à entrer dans l'espace admin
export const ADMIN_ROLES = [
  "superadmin",
  "admin",
  "manager",
  "financier",
  "employee",
];

// Rôles disposant de tous les droits de gestion (création, modification,
// assignation, annulation, paramètres...)
export const MANAGER_ROLES = ["superadmin", "admin", "manager"];

// Pages accessibles en lecture pour les rôles qui ne sont pas gestionnaires
const READ_ONLY_PATHS = {
  financier: [
    "/admin/dashboard",
    "/admin/workers",
    "/admin/gift-cards",
    "/admin/sales-suscribtions",
    "/admin/catalogue",
    "/admin/subscriptions",
    "/admin/products",
    "/admin/inventaires",
    "/admin/rapport",
    "/admin/salon",
  ],
  employee: [
    "/admin/dashboard",
    "/admin/workers",
    "/admin/gift-cards",
    "/admin/catalogue",
    "/admin/subscriptions",
    "/admin/products",
    "/admin/inventaires",
    "/admin/salon",
  ],
};

// Pages réservées aux gestionnaires même si leur page parente est visible
const MANAGER_ONLY_PATHS = [
  /^\/admin\/subscriptions\/create\/?$/,
  /^\/admin\/subscriptions\/[^/]+\/edit\/?$/,
];

const getRoleName = (user) => user?.role?.name || "";

export const canAccessAdmin = (user) => ADMIN_ROLES.includes(getRoleName(user));

export const isManager = (user) => MANAGER_ROLES.includes(getRoleName(user));

/**
 * Indique si l'utilisateur peut ouvrir une page de l'espace admin.
 * Les liens externes à /admin (ex. "/index") sont toujours autorisés.
 */
export const canAccessPath = (user, path = "") => {
  if (!path || !path.startsWith("/admin")) return true;
  if (isManager(user)) return true;

  const allowed = READ_ONLY_PATHS[getRoleName(user)] || [];

  if (MANAGER_ONLY_PATHS.some((regex) => regex.test(path))) return false;

  return allowed.some(
    (allowedPath) => path === allowedPath || path.startsWith(`${allowedPath}/`),
  );
};
